import { Center, Text, VStack } from 'native-base';
import React, { memo } from 'react';
import { NewLoanInProgressConstants } from '../../../constants';
const ListHeaderComponent = _ref => {
  let {
    title,
    description,
    selected,
    sectionIndex
  } = _ref;
  return /*#__PURE__*/React.createElement(VStack, {
    key: "list-section-header"
  }, /*#__PURE__*/React.createElement(VStack, {
    flex: 1,
    justifyContent: "center",
    alignItems: "center"
  }, /*#__PURE__*/React.createElement(Text, {
    fontSize: {
      base: '3xl',
      md: '3xl',
      lg: '3xl'
    },
    fontWeight: "light",
    fontFamily: "body",
    color: "#222A34",
    opacity: selected ? 50 : 100,
    accessibilityLabel: title,
    testID: title,
    mb: {
      base: 6,
      md: 2,
      lg: 2
    },
    mt: {
      base: sectionIndex === 1 ? 5 : 6,
      md: sectionIndex === 1 ? 6 : 7,
      lg: 8
    }
  }, title), /*#__PURE__*/React.createElement(Text, {
    color: "text.running",
    lineHeight: "2xs",
    opacity: selected ? 50 : 100,
    fontFamily: "body",
    fontWeight: "normal",
    fontSize: "sm",
    accessibilityLabel: description,
    testID: description,
    textAlign: "center",
    mb: {
      base: 9,
      md: 3,
      lg: 3
    }
  }, description)), /*#__PURE__*/React.createElement(Center, {
    w: "100%",
    mb: {
      base: 2,
      md: 7,
      lg: 3
    }
  }, /*#__PURE__*/React.createElement(Text, {
    opacity: selected ? 50 : 100,
    fontSize: "sm",
    fontWeight: "normal",
    fontFamily: "body",
    color: "black.700",
    accessibilityLabel: NewLoanInProgressConstants.UPLOAD_DOCUMENTS_NOTE,
    accessibilityRole: "text",
    testID: NewLoanInProgressConstants.UPLOAD_DOCUMENTS_NOTE
  }, NewLoanInProgressConstants.UPLOAD_DOCUMENTS_NOTE)));
};
export default /*#__PURE__*/memo(ListHeaderComponent);
//# sourceMappingURL=index.js.map